import $ from 'jquery'
import calendar from 'hotwire/calendar'
import nav from 'hotwire/nav'
import pusherStreams from 'hotwire/pusherStreams'
import {setupAsyncRolePersonDropdown} from './async_dropdown'

function animate(divId, animation) {
  const div = $(divId)
  const clear = () => { div.slideUp() }
  switch (animation) {
    case 'remain-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500)
      break
    case 'slide-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500, clear)
      break
    case 'slide-right':
      div.css({position: 'relative'})
      div.animate({left: '+=100%'}, 500, clear)
      break
    case 'slide-up':
      div.slideUp(() => removeElemOrContainer(div))
      break
    default:
      // Placate the linter
  }
}

function removeElemOrContainer(element) {
  if (!element)
    return false

  return element.remove()
}

function closeBsModal() {
  // Attempt to close the modal properly
  $('.modal-dialog .close').click()

  // Clean up artifacts from any potential failure
  $('.modal').modal('hide')
  $('.modal-backdrop').remove()
  $('body').removeClass('modal-open')
}

function enableBsPopovers(container) {
  $('[data-toggle="popover"]').popover({
    container,
    html: true,
    placement: 'bottom',
    trigger: 'click focus hover',
  })
}

function enableFrogboxes(organizationId) {
  $('.hotwired-frogbox-toggle').on('click', (event) => {
    const frogbox = $(event.target).closest('.hotwired-frogbox-toggle').data('frogbox')
    const turboframe = document.getElementById(`frogbox-${frogbox}`)

    if (turboframe.childElementCount > 0)
      turboframe.innerHTML = ''
    else
      turboframe.setAttribute('src', `/organizations/${organizationId}/dialogs/frogbox/${frogbox}`)
  })
}

function refetchCalendarEvents() {
  if ($('#js-work-items-calendar').length && window.gf?.calendar)
    window.gf.calendar.refetchEvents()
}

function refreshWorkspaceFilters() {
  ['workspace-role-filter', 'workspace-tag-filter'].forEach((frameID) => {
    if (document.getElementById(frameID))
      refreshTurboFrame(frameID)
  })
}

function refreshAfterMutation(frameID = 'page-frame', refreshUrl = document.location) {
  let refreshedPageFrame = false

  if (refreshUrl === null) {
    const refreshTarget = document.getElementById(frameID)
    if (refreshTarget && (refreshTarget.src || refreshTarget.dataset.refreshUrl)) {
      refreshTurboFrame(frameID)
    } else {
      refreshTurboFrame('page-frame', document.location)
      refreshedPageFrame = true
    }
  } else if (refreshUrl) {
    refreshTurboFrame(frameID, refreshUrl)
    refreshedPageFrame = frameID === 'page-frame'
  } else {
    refreshTurboFrame(frameID)
    refreshedPageFrame = frameID === 'page-frame'
  }

  if (!refreshedPageFrame && document.getElementById('workspace-frame'))
    refreshWorkspaceFilters()
}

function refreshTurboFrame(frameID, src = null) {
  const turboFrame = document.getElementById(frameID)
  if (turboFrame) {
    if (src) {
      turboFrame.dataset.refreshUrl = src
      turboFrame.src = src
    } else if (turboFrame.dataset.refreshUrl) {
      turboFrame.src = turboFrame.dataset.refreshUrl
    }

    turboFrame.reload()
  }
}

export default
{animate,
  calendar,
  closeBsModal,
  enableBsPopovers,
  enableFrogboxes,
  nav,
  pusherStreams,
  refreshAfterMutation,
  refetchCalendarEvents,
  refreshWorkspaceFilters,
  refreshTurboFrame,
  setupAsyncRolePersonDropdown}
